<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600"
  >
    <v-card class="rounded-0">
      <v-system-bar
        color="primary"
        dark dense
      >
        <span class="white--text font-weight-bold">{{mode==='create' ? 'Добавление подразделения' : 'Редактирование подразделения'}}</span>
      </v-system-bar>
        <v-row dense no-gutters>
          <v-col cols="12" class="pa-1">
            <v-alert
              dense
              icon="mdi-folder"
              border="left"
              colored-border
              color="amber darken-1"
              type="info"
              elevation="2"
              class="rounded-0"
            >
              {{nodeName}}
            </v-alert>
          </v-col>
          <v-col cols="12" class="pa-1">
            <org-division-select
              v-model="divisionID"
              :org="org"
              :label="'Родительское подразделение'"
              :filter="divFilter"
              :idMode="true"
            ></org-division-select>
          </v-col>
          <v-col cols="12" class="pa-1">
            <v-text-field
              v-model="shortName"
              label="Краткое наименование подразделения"
              type="text"
              required
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="pa-1">
            <v-text-field
              v-model="fullName"
              label="Полное наименование подразделения"
              type="text"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          text
          @click="onCloseEvent"
        >Отмена</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="onSaveEvent"
          :disabled="saveDisabled"
        >Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ORG_ADD_DIVISION, ORG_UPD_DIVISION } from '@/store/actions/org'
import { UI_SNACKBAR } from '@/store/actions/ui'
import OrgDivisionSelect from '@/components/modules/org/clients/components/orgDivisionSelect'

export default {
  name: 'addDivisionDialog',
  props: ['value', 'org', 'mode', 'division'],
  components: {
    OrgDivisionSelect
  },
  data () {
    return {
      divisionID: undefined,
      divShortName: '',
      changedSN: false,
      divFullName: '',
      changedFN: false
    }
  },
  computed: {
    saveDisabled: {
      get: function () {
        const haveITPID = this.divisionID
        const haveOrgUUID = this.org && this.org.INST_UUID
        const haveFullName = this.mode === 'create' ? this.divFullName : this.changedFN
        const haveShortName = this.mode === 'create' ? this.divShortName : this.changedSN
        const parentChanged = this.mode === 'create' ? this.divisionID : this.divisionID !== this.division.PITP
        if (this.mode === 'create') {
          return !(haveITPID && haveOrgUUID && haveFullName && haveShortName)
        } else {
          return !(haveFullName || haveShortName || parentChanged)
        }
      }
    },
    nodeName: {
      get: function () {
        return this.division ? this.division.ITP_NAME : 'Не задано'
      }
    },
    shortName: {
      get: function () {
        if (this.mode === 'create') {
          return this.divShortName
        } else {
          if (this.changedSN) {
            return this.divShortName
          }
          return this.division ? this.division.ITP_NAME : ''
        }
      },
      set: function (val) {
        this.divShortName = val
        this.changedSN = this.divShortName !== this.division.ITP_NAME
      }
    },
    fullName: {
      get: function () {
        if (this.mode === 'create') {
          return this.divFullName
        } else {
          if (this.changedFN) {
            return this.divFullName
          }
          return this.division ? this.division.ITP_MNEMO : ''
        }
      },
      set: function (val) {
        this.divFullName = val
        this.changedFN = this.divFullName !== this.division.ITP_MNEMO
      }
    }
  },
  watch: {
    division (val) {
      if (val) {
        if (this.mode === 'create') {
          this.divisionID = val.ITP_ID || val.NODE_ID
        }
        if (this.mode === 'edit') {
          this.divisionID = val.PITP
        }
      }
    },
    mode (val) {
      if (val) {
        if (val === 'create') {
          this.divisionID = this.division.ITP_ID
        }
        if (val === 'edit') {
          this.divisionID = this.division.PITP
        }
      }
    },
    org (val) {
      if (!val) {
        this.$emit('input', false)
      }
    }
  },
  methods: {
    divFilter (item) {
      return item.IS_STATE !== '1'
    },
    clearForm () {
      this.divisionID = null
      this.divShortName = ''
      this.changedSN = false
      this.divFullName = ''
      this.changedFN = false
    },
    onSaveEvent () {
      if (this.mode === 'create') {
        this.addDept()
      }
      if (this.mode === 'edit') {
        this.editDept()
      }
    },
    onCloseEvent () {
      this.clearForm()
      this.$emit('input', false)
    },
    addDept () {
      const params = {
        INST_UUID: this.org.INST_UUID,
        ITP_ID: this.divisionID,
        ITP_NAME: this.shortName,
        ITP_MNEMO: this.fullName
      }
      this.$store.dispatch(ORG_ADD_DIVISION, params)
        .then((resp) => {
          this.$emit('onDivisionAdded', resp)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка добавления данных' + err })
          console.log('Ошибка добавления подразделения ', err)
        })
    },
    editDept () {
      if (this.division.ITP_ID === this.divisionID) {
        alert('Подразделение не может быть подчинено само себе, исправьте поле "Родительское подразделение"')
        return
      }
      const params = {
        INST_UUID: this.org.INST_UUID,
        ITP_ID: this.division.ITP_ID,
        PITP: this.divisionID,
        ITP_NAME: this.shortName,
        ITP_MNEMO: this.fullName
      }
      this.$store.dispatch(ORG_UPD_DIVISION, params)
        .then((resp) => {
          this.$emit('onDivisionChanged', resp)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка обновления данных ' + err })
          console.log('Ошибка обновления данных подразделения', err)
        })
    }
  },
  mounted () {
    console.log('addDivisionDialog mounted. Org is ', this.org, 'Mode is ', this.mode, '. Division is ', this.division)
  }
}
</script>
